import { css } from '@emotion/react'
import { memo, useCallback } from 'react'
import { goToRoom } from '../../../../actions/nav'
import { SettingsType } from '../../../../constants/enums'
import { getRecommendationPercentage } from '../../../../mfcLogic/recommendation'
import { getAnimationsEnabledfromUeopt } from '../../../../mfcLogic/settings'
import { event } from '../../../../utilities/analytics'
import { useModelColor } from '../../../Hooks/useModelColor'
import { useScreenStateSelector } from '../../../Hooks/useScreenState'
import { useSettingSelector } from '../../../Hooks/useSettings'
import { useUserSelector } from '../../../Hooks/useUser'
import PercentageBar from '../../../common/PercentageBar'
import APP_BREAKPOINTS, { maxWindowWidth } from '../../../styles/breakpoints'
import PreviewPosterImage from '../../PreviewPosterImage'
import { modelNameStyles } from '../shared'

const rootStyles = css({
    width: '100%',
    maxWidth: '100%',
})
const containerStyles = css({
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
})
const responsiveNameStyles = css({
    [maxWindowWidth(APP_BREAKPOINTS.s)]: {
        fontSize: 12,
    },
    [maxWindowWidth(400)]: {
        fontSize: 11,
    },
})

interface GridProps {
    id: number
    recommendation: number
    inRoomOrProfile?: boolean
}

const Grid = (props: GridProps) => {
    const { id, recommendation, inRoomOrProfile } = props
    const matchPercentage: number = getRecommendationPercentage(recommendation)
    const [animatePreviews] = useSettingSelector(
        SettingsType.DEFAULT,
        'animatePreviews',
    )

    const staticImage = !getAnimationsEnabledfromUeopt(animatePreviews)
    const color = useUserSelector(id, 'color')
    const name = useUserSelector(id, 'name')
    const slug = useUserSelector(id, 'slug')
    const windowWidth = useScreenStateSelector('windowWidth')
    const reducedSize = windowWidth <= APP_BREAKPOINTS.s
    const modelColor = useModelColor(color)
    const displayName = name || slug

    const onClickOpenRoom = useCallback(() => {
        event({
            action: `model_you_may_like_poster_clickthrough`,
            category: 'user_interactions',
            label: 'interaction',
            value: true,
        })
        goToRoom(slug)
    }, [slug, inRoomOrProfile])

    if (!name) {
        return null
    }

    return (
        <section
            key={id}
            css={rootStyles}
            data-testid="ModelsYouMayLike__PosterItem"
        >
            <article css={containerStyles}>
                <div>
                    <div>
                        <div css={{ width: '100%' }}>
                            <span
                                css={[modelNameStyles, responsiveNameStyles]}
                                style={{ color: modelColor }}
                            >
                                {displayName}
                            </span>
                        </div>
                    </div>
                    <PreviewPosterImage
                        onClick={onClickOpenRoom}
                        id={id}
                        height={!reducedSize ? 81.5625 : 61.171875}
                        width={!reducedSize ? 145 : 108.75}
                        staticImage={staticImage}
                        rounded
                    />
                    <PercentageBar
                        percentage={matchPercentage}
                        color={modelColor}
                    />
                </div>
            </article>
        </section>
    )
}

export default memo(Grid)
